import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, unref as _unref, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 3 }

import { onMounted, reactive, ref } from "vue";
import { CarouselService } from "@/api/services/CarouselService";
import { ListRequest } from "@/api/models/ListRequest";
import { Carousel } from "@/api/models/carousel/Carousel";
import { message } from "ant-design-vue";
import { ToImage } from "@/utils/image";
import dayjs from "dayjs";
import { ColumnType } from "ant-design-vue/lib/table";
import { CarouselUpdateRequest } from "@/api/models/carousel/CarouselUpdateRequest";
import { CarouselAddRequest } from "@/api/models/carousel/CarouselAddRequest";
import FileUpload from "@/components/FileUpload.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CarouselView',
  setup(__props) {

const total = ref<number>(0);

const listRequest = reactive<ListRequest>({
  current: 1,
  size: 20,
  content: "",
});

const carouselList = ref<Carousel[]>([]);

const handleList = async () => {
  const res = await CarouselService.ListAll(listRequest);
  if (res.code === 0) {
    carouselList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error(res.msg);
  }
};

onMounted(async () => {
  await handleList();
});

const handleSizeChange = (current: number, pageSize: number) => {
  listRequest.current = current;
  listRequest.size = pageSize;
  handleList();
};

const handleChange = (page: number, pageSize: number) => {
  listRequest.current = page;
  listRequest.size = pageSize;
  handleList();
};

const openAdd = ref(false);

const addRequest = reactive<CarouselAddRequest>({
  name: "",
  image_url: "",
  level: 1,
  category: 1,
});

const submitAdd = async () => {
  const res = await CarouselService.Add(addRequest);
  if (res.code === 0) {
    message.success("添加成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const openUpdate = ref(false);

const updateRequest = reactive<CarouselUpdateRequest>({
  id: 0,
  name: "",
  image_url: "",
  level: 0,
  category: 0,
  is_delete: 0,
});

const handleUpdate = (record: Carousel) => {
  openUpdate.value = true;
  Object.assign(updateRequest, record);
};

const submitUpdate = async () => {
  const res = await CarouselService.Update(updateRequest);
  if (res.code === 0) {
    message.success("修改成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDelete = async (record: Carousel) => {
  const res = await CarouselService.Delete(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDrop = async (record: Carousel) => {
  const res = await CarouselService.Drop(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const columns: ColumnType[] = [
  {
    title: "Id",
    dataIndex: "id",
    align: "center",
  },
  {
    title: "轮播名称",
    dataIndex: "name",
    align: "center",
  },
  {
    title: "优先级",
    dataIndex: "level",
    align: "center",
  },
  {
    title: "轮播位置",
    dataIndex: "category",
    align: "center",
  },
  {
    title: "图片",
    dataIndex: "image_url",
    align: "center",
  },
  {
    title: "状态",
    dataIndex: "is_delete",
    align: "center",
  },
  {
    title: "创建时间",
    dataIndex: "create_at",
    align: "center",
  },
  {
    title: "操作",
    dataIndex: "operator",
    align: "center",
  },
];

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_button, {
      type: "primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (openAdd.value = true)),
      style: {"margin-bottom":"16px"}
    }, {
      default: _withCtx(() => _cache[12] || (_cache[12] = [
        _createTextVNode(" 添加轮播图 ")
      ])),
      _: 1
    }),
    _createVNode(_component_a_table, {
      columns: columns,
      "data-source": carouselList.value,
      pagination: {
        current: listRequest.current,
        pageSize: listRequest.size,
        total: total.value,
        showSizeChanger: true,
        pageSizeOptions: [10, 20, 30, 40, 50],
        onChange: handleChange,
        onShowSizeChange: handleSizeChange,
      },
      bordered: ""
    }, {
      bodyCell: _withCtx(({ column, record }: { column: ColumnType, record: Carousel }) => [
        (column.dataIndex === 'category')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (record.category === 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, "首页"))
                : _createCommentVNode("", true),
              (record.category === 2)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, "商城"))
                : _createCommentVNode("", true)
            ], 64))
          : (column.dataIndex === 'image_url')
            ? (_openBlock(), _createBlock(_component_a_image, {
                key: 1,
                src: _unref(ToImage)(record.image_url),
                style: {"height":"60px","width":"auto"}
              }, null, 8, ["src"]))
            : (column.dataIndex === 'is_delete')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (record.is_delete === 1)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 0,
                        color: "green"
                      }, {
                        default: _withCtx(() => _cache[13] || (_cache[13] = [
                          _createTextVNode("正常")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (record.is_delete === 2)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 1,
                        color: "red"
                      }, {
                        default: _withCtx(() => _cache[14] || (_cache[14] = [
                          _createTextVNode("回收站")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : (column.dataIndex === 'create_at')
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(dayjs)(record.create_at).format("YYYY-MM-DD HH:mm:ss")), 1))
                : (column.dataIndex === 'operator')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                      _createVNode(_component_a_button, {
                        onClick: ($event: any) => (handleUpdate(record)),
                        type: "primary",
                        style: { marginRight: '8px' }
                      }, {
                        default: _withCtx(() => _cache[15] || (_cache[15] = [
                          _createTextVNode("编辑 ")
                        ])),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_a_button, {
                        onClick: ($event: any) => (submitDelete(record)),
                        type: "primary",
                        style: {
              backgroundColor: '#ff7a45',
              color: 'white',
              marginRight: '8px',
            }
                      }, {
                        default: _withCtx(() => _cache[16] || (_cache[16] = [
                          _createTextVNode("删除 ")
                        ])),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_a_button, {
                        onClick: ($event: any) => (submitDrop(record)),
                        type: "primary",
                        style: {
              backgroundColor: '#ff4d4f',
              color: 'white',
            }
                      }, {
                        default: _withCtx(() => _cache[17] || (_cache[17] = [
                          _createTextVNode("彻底删除 ")
                        ])),
                        _: 2
                      }, 1032, ["onClick"])
                    ], 64))
                  : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["data-source", "pagination"]),
    _createVNode(_component_a_modal, {
      open: openAdd.value,
      "onUpdate:open": _cache[5] || (_cache[5] = ($event: any) => ((openAdd).value = $event)),
      title: "添加轮播图数据",
      onOk: submitAdd,
      cancelText: "取消"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { model: addRequest }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "轮播图名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: addRequest.name,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((addRequest.name) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "优先级" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_number, {
                  value: addRequest.level,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((addRequest.level) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "类别" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: addRequest.category,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((addRequest.category) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => _cache[18] || (_cache[18] = [
                        _createTextVNode("首页")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 2 }, {
                      default: _withCtx(() => _cache[19] || (_cache[19] = [
                        _createTextVNode("商城")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "图片" }, {
              default: _withCtx(() => [
                _createVNode(FileUpload, {
                  modelValue: addRequest.image_url,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((addRequest.image_url) = $event)),
                  style: {"display":"block"}
                }, null, 8, ["modelValue"]),
                (addRequest.image_url !== '')
                  ? (_openBlock(), _createBlock(_component_a_image, {
                      key: 0,
                      src: _unref(ToImage)(addRequest.image_url),
                      style: {"max-height":"150px","display":"block","margin-top":"10px"}
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_a_modal, {
      open: openUpdate.value,
      "onUpdate:open": _cache[11] || (_cache[11] = ($event: any) => ((openUpdate).value = $event)),
      title: "修改轮播图数据",
      onOk: submitUpdate,
      cancelText: "取消"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: updateRequest,
          style: {"margin-top":"20px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "轮播图名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: updateRequest.name,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((updateRequest.name) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "优先级" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_number, {
                  value: updateRequest.level,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((updateRequest.level) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "类别" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: updateRequest.category,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((updateRequest.category) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => _cache[20] || (_cache[20] = [
                        _createTextVNode("首页")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 2 }, {
                      default: _withCtx(() => _cache[21] || (_cache[21] = [
                        _createTextVNode("商城")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: updateRequest.is_delete,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((updateRequest.is_delete) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => _cache[22] || (_cache[22] = [
                        _createTextVNode("正常")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 2 }, {
                      default: _withCtx(() => _cache[23] || (_cache[23] = [
                        _createTextVNode("回收站")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "图片" }, {
              default: _withCtx(() => [
                _createVNode(FileUpload, {
                  modelValue: updateRequest.image_url,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((updateRequest.image_url) = $event)),
                  style: {"display":"block"}
                }, null, 8, ["modelValue"]),
                _createVNode(_component_a_image, {
                  src: _unref(ToImage)(updateRequest.image_url),
                  style: {"max-height":"150px","display":"block","margin-top":"10px"}
                }, null, 8, ["src"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}
}

})